<template>
    <v-chart class="chart" :option="chartOption" :autoresize="true" theme="report-theme" ref="chartInstance"/>
</template>

<script>
import {use, registerTheme} from "echarts/core";
import {CanvasRenderer} from "echarts/renderers";
import {PieChart} from "echarts/charts";
import {
    TitleComponent,
    TooltipComponent,
    LegendComponent
} from "echarts/components";
import VChart from "vue-echarts";

import reportTheme from '@/configurations/iotag_echarts_report_theme.json'

use([
    CanvasRenderer,
    PieChart,
    TitleComponent,
    TooltipComponent,
    LegendComponent
]);

// registering custom theme
registerTheme("report-theme", reportTheme);

export default {

    components: {
        VChart
    },

    beforeMount() {
        this.setupChart();
    },

    data() {
        return {
            chartOption: null,
        };
    },
    props: {
        chartData: {
            type: Array,
            default() {
                return []
            }
        },
    },
    methods: {
        setupChart() {
            this.chartOption = {
                fontFamily: "'Unica One', sans-serif",
                tooltip: {
                    trigger: "item",
                    formatter: function (args) {
                        return `${args.marker} ${args.name} <b>${parseFloat(Number(args.value).toFixed(1))}% </b><br>`;
                    }
                },
                legend: {
                    top: "bottom",
                    left: "center",
                },
                series: []
            }
        },
        setupSeries(chartData) {
            let data = chartData.map(function (item) {
                if (parseFloat(Number(item.value).toFixed(1)) === 0) {
                    return {
                        ...item,
                        label: {show: false}
                    };
                }

                return item;
            });

            this.chartOption.series = [
                {
                    colorBy: 'data',
                    minShowLabelAngle: 0,
                    label: {
                        show: true,
                        position: 'outside',
                        color: '#fff',
                        backgroundColor: 'inherit',
                        padding: [3, 6],
                        borderRadius: 4,
                        fontSize: 12,
                        formatter: function (d) {
                            let value = parseFloat(Number(d.data.value).toFixed(1));

                            if (value === 0) {
                                return '';
                            }

                            return value + '%';
                        }
                    },
                    labelLine: {
                        show: true,
                        length: 10,
                        length2: 8,
                        lineStyle: {
                            color: 'inherit'
                        }
                    },
                    labelLayout: {
                        hideOverlap: false
                    },
                    type: "pie",
                    data: data,
                    radius: '58%',
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: "rgba(0, 0, 0, 0.5)"
                        }
                    },
                    center: ['50%', '42%']
                }
            ]
        },
    },
    watch: {
        chartData: {
            deep: true,
            handler(val) {
                if (val.length === 0) {
                    if (this.chartOption && this.chartOption.series && this.chartOption.series.length > 0 &&
                        this.chartOption.series[0].data) {
                        this.$refs.chartInstance.chart.clear();
                    }
                } else {
                    this.setupSeries(JSON.parse(JSON.stringify(val)));
                }
            }
        },
    },
};
</script>

<style scoped>
.chart {
    height: 400px;
}
</style>
